


















































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import AddEditModal from './components/add-edit-modal.vue';
import * as _ from 'lodash';

import {
  getPositionGroupList,
  getOrgsFirstLevel,
  IGetPositionGroupListParam,
  deletePositionGroup
} from '@/api/system-management/index';
import Utils from '@root/utils/common';
import value from '*.json';
import ModalConfig from '@/components/modal-config/index.vue';
@Component({
  name: 'RoleGroupList',
  components: {
    AddEditModal,
    ModalConfig
  }
})
export default class RoleGroupList extends Mixins(TableMixin, TableWidthMixin) {
  // 查询条件
  orgDepId: string = ''; // 机构id
  jobDefinitionsName = ''; // 岗位名称
  orgDepOptions = []; // 机构下拉选项

  tableData: any[] = []; // 表数据
  tableLoading: boolean = false;

  // 弹窗控制
  addEditModalVisible: boolean = false;
  isEdit: boolean = false;
  isDetail: boolean = false;
  addEditModalData: any = [];
  orgVisible: boolean = false;
  orgNameList: any[] = [];
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '岗位组名称',
        dataIndex: 'jobDefinitionsName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '所属机构',
        dataIndex: 'orgDepName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '关联机构',
        dataIndex: 'orgNumber',
        scopedSlots: { customRender: 'orgNumber' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  /**
   * 生命周期
   */

  async mounted() {
    // 获取机构列表信息
    this.fetchTableData();
    this.getOrgsFirstLevel();
  }

  /**
   * method
   */

  /**
   * 查询机构列表
   */
  async fetchTableData(isRefresh?: boolean) {
    if (this.tableLoading) return false;
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    try {
      const { status, code, msg, data } = await getPositionGroupList({
        orgDepId: this.orgDepId,
        jobDefinitionsName: this.jobDefinitionsName,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { datas = [], totalNum = 0 } = data || {};
      this.tableData = datas;
      this.total = Number(totalNum);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * 表格查询条件清空
   */
  onTableFilterClear() {
    this.orgDepId = ''; // 机构Id
    this.jobDefinitionsName = ''; // 岗位名称
    this.fetchTableData(true);
  }

  async getOrgsFirstLevel() {
    try {
      const { status, code, msg, data = [] } = await getOrgsFirstLevel();
      this.orgDepOptions = data.map((item: any) => {
        return {
          label: item.orgDepName,
          value: item.orgDepId
        };
      });
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  /**
   * 表格行删除
   */
  async deleteItem(key: string) {
    try {
      const { status, code, msg, data } = await deletePositionGroup({
        jobDefinitionsId: key
      });
      this.$message.success('删除成功');
      this.fetchTableData();
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  /**
   * 新建弹窗展示
   */
  showAddModal() {
    this.isEdit = false;
    this.isDetail = false;
    this.addEditModalVisible = true;
  }

  /**
   * 编辑弹窗展示
   */
  showEditModal(item: any) {
    this.isEdit = true;
    this.isDetail = false;
    this.addEditModalData = item;
    this.addEditModalVisible = true;
  }

  /**
   * 详情查看弹窗展示
   */
  showDetailModal(item: any) {
    this.isEdit = false;
    this.isDetail = true;
    this.addEditModalData = item;
    this.addEditModalVisible = true;
  }

  /**
   * 弹窗取消
   */
  handleModalCancel() {
    this.addEditModalVisible = false;
  }
  /**
   * 弹窗保存
   */
  handleModalCreate() {
    this.addEditModalVisible = false;
    this.fetchTableData();
  }
  //关联机构详情
  toOrgName(record: any) {
    if (record.orgNumber) {
      this.orgNameList = record.orgNames;
      this.orgVisible = true;
    }
  }
  //关闭关联机构详情
  closeOrg() {
    this.orgVisible = false;
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
